import { PairVwap } from "../model/core/PairVwap";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

export const CHANNEL_VWAP_SERVICE: string = "VwapServiceChannel";

export class Vwap {
  public pairVWaps: Array<PairVwap>;
  public netVwap: PairVwap;
}

export interface IVwapService {
  getVwapForOrders(orderIds: Array<string>, ndfMode: boolean): Promise<Vwap>;
}
